<template>
  <div class="container-fluid mt-5 page-padding margin_80_35">
    <div class="row pt-3" v-if="currentCategory">
      <div class="col-12">
        <nav class="faq-breadcrumb" aria-label="breadcrumb">
          <router-link to="/home">Home</router-link>
          <span class="faq-breadcrumb-sep">/</span>
          <router-link to="/faq">FAQ</router-link>
          <span class="faq-breadcrumb-sep">/</span>
          <span class="faq-breadcrumb-current">{{ currentCategory.Title }}</span>
        </nav>

        <h1 class="faq-category-page-title">{{ currentCategory.Title }}</h1>
        <p v-if="currentCategory.Description" class="faq-category-page-desc">{{ currentCategory.Description }}</p>

        <div class="faq-subcategory-filters" v-if="currentCategory.ChildCategory && currentCategory.ChildCategory.length > 0">
          <button type="button" class="faq-filter-chip" :class="{ active: activeSubCategoryId === 0 }" @click="activeSubCategoryId = 0">All</button>
          <button type="button" class="faq-filter-chip" v-for="child in currentCategory.ChildCategory" :key="child.Id"
            :class="{ active: activeSubCategoryId === child.Id }" @click="activeSubCategoryId = child.Id">{{ child.Title }}</button>
        </div>

        <ul class="faq-question-list" v-if="filteredFaqs.length > 0">
          <li v-for="faq in filteredFaqs" :key="faq.Id">
            <router-link :to="'/faq/' + categoryId + '/' + faq.Id">
              <span>{{ faq.Question }}</span>
              <i class="fa fa-angle-right"></i>
            </router-link>
          </li>
        </ul>
        <div v-else-if="loaded" class="py-5 text-center">
          <p>No questions found in this topic yet.</p>
        </div>
      </div>
    </div>

    <div class="row pt-3" v-else-if="loaded">
      <div class="col-12 text-center py-5">
        <p>This category could not be found.</p>
        <router-link to="/faq">Back to FAQ</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import CategoryService from '../services/category-service'
import FAQService from '../services/faq-service'

export default {
  name: 'CategoryFaqList',
  data() {
    return {
      categorylist: [],
      faqList: [],
      activeSubCategoryId: 0,
      loaded: false
    }
  },
  computed: {
    categoryId() {
      return parseInt(this.$route.params.categoryId)
    },
    currentCategory() {
      var categoryId = this.categoryId
      return this.categorylist.find(function (c) { return c.Id === categoryId }) || null
    },
    filteredFaqs() {
      if (this.activeSubCategoryId > 0) {
        var subId = this.activeSubCategoryId
        return this.faqList.filter(function (f) { return f.SubCategoryId === subId })
      }
      return this.faqList
    }
  },
  watch: {
    '$route.params.categoryId'() {
      this.activeSubCategoryId = 0
      this.fetchFaqs()
    },
    currentCategory(category) {
      if (category) {
        document.title = category.Title + ' FAQ | Circleram'
      }
    }
  },
  mounted() {
    this.fetchCategories()
    this.fetchFaqs()
  },
  methods: {
    fetchCategories() {
      CategoryService.getcategoryList().then(response => {
        if (response.data.Status && response.data.Object) {
          this.categorylist = response.data.Object.categories
        }
      }, (error) => {
        console.log(error)
      })
    },
    fetchFaqs() {
      if (!this.$route.params.categoryId) return
      this.loaded = false
      FAQService.getFilteredFaqList(true, this.categoryId, null).then(response => {
        if (response.data.Status) {
          this.faqList = response.data.Object.faqs
        } else {
          this.faqList = []
        }
        this.loaded = true
      }, (error) => {
        console.log(error)
        this.faqList = []
        this.loaded = true
      })
    }
  }
}
</script>

<style scoped>
.faq-breadcrumb {
  font-size: 14px;
  margin-bottom: 16px;
}
.faq-breadcrumb-sep {
  margin: 0 6px;
  color: #999;
}
.faq-breadcrumb-current {
  color: #666;
}
.faq-category-page-title {
  margin-bottom: 8px;
}
.faq-category-page-desc {
  color: #777;
  margin-bottom: 20px;
}
.faq-subcategory-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 24px;
}
.faq-filter-chip {
  border: 1px solid #ddd;
  background: #fff;
  border-radius: 16px;
  padding: 6px 16px;
  font-size: 13px;
  cursor: pointer;
  transition: all .15s ease;
}
.faq-filter-chip.active {
  background: #5b4fff;
  border-color: #5b4fff;
  color: #fff;
}
.faq-question-list {
  list-style: none;
  padding: 0;
  margin: 0;
  border-top: 1px solid #ededed;
}
.faq-question-list li {
  border-bottom: 1px solid #ededed;
}
.faq-question-list li a {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 4px;
  color: inherit;
  text-decoration: none;
}
.faq-question-list li a:hover {
  color: #5b4fff;
}
.faq-question-list li a i {
  color: #bbb;
  flex-shrink: 0;
  margin-left: 12px;
}
</style>
